module.exports = __webpack_public_path__ + "assets/img/DS-living dinning (13).37ba9af7.jpg";